export type ImageGenerationPriceLevel = 0 | 1 | 2;

export const IMAGE_GENERATION_PRICE_BY_LEVEL: Record<
  ImageGenerationPriceLevel,
  { character: number; page: number }
> = {
  0: { character: 32, page: 36 },
  1: { character: 26, page: 28 },
  2: { character: 22, page: 25 }
};

export function normalizeImageGenerationPriceLevel(value: unknown): ImageGenerationPriceLevel {
  const level = Number(value);
  return level === 1 || level === 2 ? level : 0;
}
